import { render, staticRenderFns } from "./AreaSupportIndex.vue?vue&type=template&id=2f8fb650"
import script from "./AreaSupportIndex.vue?vue&type=script&lang=js"
export * from "./AreaSupportIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports